export default __webpack_public_path__ + "static/media/caixa@2x.ff219b26.png";